import { Subscription } from 'rxjs';
import {
  ActualSubmenu,
  ActualMenu,
} from './interfaces/actual-submenu.interface';
import { Event, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Module } from './../services/menu/responses/menu.response';
import {
  Component,
  OnInit,
  HostListener,
  Input,
  OnDestroy,
  SimpleChanges,
  OnChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ClienteService } from 'src/app/shared/services/cliente/cliente.service';

@Component({
  selector: 'app-menu-nav-bar',
  templateUrl: './menu-nav-bar.component.html',
  styleUrls: ['./menu-nav-bar.component.scss'],
})
export class MenuNavBarComponent implements OnInit, OnChanges, OnDestroy {
  MOBILE_WIDTH = 780;
  innerWidth: number;

  @Input() modules: Module[] = [];
  actualSubmenu: ActualSubmenu = null;

  listenRoutesSubscription$: Subscription;

  @ViewChild('collapseSubmenuCmp')
  collapseMobile: ElementRef;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private clientS: ClienteService
  ) {
    this.listenRoutes();
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['modules'] &&
      changes['modules'].previousValue &&
      changes['modules'].currentValue &&
      changes['modules'].previousValue.length !==
        changes['modules'].currentValue.length
    ) {
      this.updateActualSubmenu(this.router.url);
    }
  }

  listenRoutes() {
    this.listenRoutesSubscription$ = this.router.events.subscribe(
      (event: Event) => {
        if (event instanceof NavigationEnd) {
          this.updateActualSubmenu(event.urlAfterRedirects);
        }
      }
    );
  }

  updateActualSubmenu(url: string) {
    if (url.endsWith('/')) {
      url = url.substr(0, url.length - 1);
    }
    const candidatos: ActualSubmenu[] = [];
    for (let i = 0; i < this.modules.length; i++) {
      const modu = this.modules[i];
      for (let j = 0; j < modu.menu.length; j++) {
        const menu = modu.menu[j];
        for (let k = 0; k < menu.sub_menu.length; k++) {
          const submenu = menu.sub_menu[k];
          if (url.includes(submenu.url || '-nope-')) {
            let actualMenu: ActualMenu = { ...menu, module: modu };
            const actualSubmenu = { ...submenu, menu: actualMenu };
            candidatos.push(actualSubmenu);
          }
        }
      }
    }
    if (candidatos.length > 0) {
      for (let i = 0; i < candidatos.length; i++) {
        if (url === candidatos[i].url) {
          this.actualSubmenu = candidatos[i];
          return;
        }
      }
      this.actualSubmenu = candidatos[candidatos.length - 1];
      return;
    }
    this.actualSubmenu = null;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  isDesktop() {
    return this.innerWidth >= this.MOBILE_WIDTH;
  }

  ngOnDestroy(): void {
    if (this.listenRoutesSubscription$) {
      this.listenRoutesSubscription$.unsubscribe();
    }
  }

  tryCollapseMobile() {
    if (this.collapseMobile) {
      this.collapseMobile.nativeElement.classList.remove('show');
    }
  }
  auditoria(url: any) {
    const usuario = JSON.parse(
      localStorage.getItem('AdminImplementos.usuario')
    );
    const { codEmpleado, codUsuario, nombre } = JSON.parse(usuario);
    const [, app, modulo, menu1] = url.split('/');

    const params = {
      codEmpleado,
      codUsuario,
      user: nombre,
      app,
      modulo,
      menu: menu1 ? menu1 : '',
      plataforma: 'web',
    };

    this.clientS.guardaAuditoria(params).subscribe();
  }
}
